/**
 * 
 * 
 * Route Layout
 * 
 */


import React from 'react'
import { connect } from 'react-redux'
import Grid from './Grid'
import PropTypes from 'prop-types'


function RouteLayout(props) {
    const { children, grid } = props

    return <React.Fragment>
        {grid && grid.length > 0 ? <div className="page-content">
            <Grid {...props} />
            {children}
        </div> : children}
    </React.Fragment>
}

RouteLayout.propTypes = {
    grid: PropTypes.any,
    children: PropTypes.any
}



const mapStateToProps = (state, { selectors, location = {} }) => {
    const {
        selectError,
        selectLoading,
        selectRecords,
        selectRecordsMetaData,
        selectSuccess
    } = selectors

    return {
        error: selectError()(state),
        loading: selectLoading()(state),
        records: selectRecords()(state),
        metaData: selectRecordsMetaData()(state),
        success: selectSuccess()(state),
        access: location && location.state && location.state.access || []
    }
}

export default connect(mapStateToProps)(RouteLayout)